import { TooltipConfiguration } from "../entity";

export abstract class Tooltip {

    protected tooltip: HTMLElement;

    protected constructor(protected configuration: TooltipConfiguration,) {
        this.tooltip = this.createTooltipElementWith(configuration.cssClass);
        this.appendText(configuration.text);
    }

    public append() {
        throw new Error('Tooltip append method not implemented.');
    }

    public remove() {
        throw new Error('Tooltip remove method not implemented.');
    }

    private createTooltipElementWith(cssClass?: string): HTMLElement {
        const element = document.createElement('div');

        if (cssClass) {
            element.classList.add(cssClass);
        }

        return element;
    }

    private appendText(text: string) {
        this.tooltip.innerHTML = text;
    }
}
